<template>
  <div class="wg-filters">
    <div class="filters-title">
      {{ $anm22.strLang(language, "Filters", "Filtri") }}:
    </div>
    <div
      v-for="(filter, index) in filters"
      :key="'filter-' + index"
      :class="'filter' + (filter.value !== null ? ' selected' : '')"
      @click="filter.action"
    >
      {{ filter.label }} {{ filter.valueLabel }}
    </div>
    <img
      v-if="exportBtn"
      :src="$anm22.icons.getWorldIcon('download')"
      @click="exportAction"
      :title="$anm22.strLang(language, 'Export', 'Esporta')"
      class="export-btn"
    />
  </div>
</template>

<script>
export default {
  props: {
    filters: {
      type: Array,
      default: [],
    },
    language: {
      type: String,
      default: "en",
    },
    exportBtn: {
      type: Boolean,
      default: false,
    },
    exportAction: {
      type: Function,
      default: () => {},
    },
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "../../libs/anm22_web_graphics/v1/scss/filters";
</style>
